export default "__VITE_ASSET__ozZP9vmE__"